import React, { memo, useCallback, useEffect } from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import { useQuery } from 'react-apollo-hooks';
import classNames from 'classnames'
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { CategoriesFilter, ItemListLoading, Loading } from '../../../components';
import { ICountry, ITourEdge, ITour, IToursQueryVariables, IToursQueryData, ILocation, ToursQuery, TourOrderByEnum, OrderByDirectionEnum, IToursFilter, withAppStoreValue } from '../../../store';
import { Tours } from '.';
import { ToursMapView } from './toursMapView';
import { ToursSectionStoreDispatchAction, withToursSectionStoreValue, EToursSectionStateActionTypes } from '../store';
import { INearByTour, IAroundMe } from '../common';
import tour from '../../../store/reducers/tour';

interface IToursPageContentToursStoreProps {
    dispatch: ToursSectionStoreDispatchAction
    orderBy: TourOrderByEnum
    orderByDirection: OrderByDirectionEnum
    showCategories: boolean
    showMap: boolean
}

interface IComponentCoreAppStoreProps {
    filter: IToursFilter
}

export const ToursPageContentCore = memo(withRouter((props: RouteComponentProps & IToursPageContentToursStoreProps & IComponentCoreAppStoreProps) => {
    console.log("Render ToursPageContent")

    // Break it down into subcomponents - map and categories filter are not related to tours list
    const { dispatch, orderBy, orderByDirection, showMap, showCategories, filter } = props
    const { country = undefined, location = undefined, filterByRegion = undefined, aroundMe = undefined, searchText = undefined, nearByTour = undefined, tourId = undefined } = props.location.state || {}

    const actualCountry = country as ICountry
    const actualLocation = location as ILocation
    const actualAroundMe = aroundMe as IAroundMe
    const actualSearchText = searchText as string
    const actualNearByTour = nearByTour as INearByTour

    let area = undefined
    if (actualNearByTour) {
        area = {
            center: {
                lat: actualNearByTour.tour.lat,
                lng: actualNearByTour.tour.lng
            },
            radius: actualNearByTour.distance
        }
    } else if (actualAroundMe) {
        area = {
            center: {
                lat: actualAroundMe.center.lat,
                lng: actualAroundMe.center.lng
            },
            radius: actualAroundMe.distance
        }
    }

    const { i18n: { languages: [language] } } = useTranslation()
    const { data, loading, fetchMore } = useQuery<any, IToursQueryVariables, any>(ToursQuery, {
        variables: {
            where: {
                language,
                countryId: actualCountry ? actualCountry.id : undefined,
                locationId: !filterByRegion && actualLocation ? actualLocation.id : undefined,
                region: filterByRegion && actualLocation ? actualLocation.region : undefined,
                area,
                searchText: actualSearchText || undefined,
                exclude: actualNearByTour ? [actualNearByTour.tour.id] : undefined,
                ...filter
            },
            order: {
                by: TourOrderByEnum[orderBy],
                direction: OrderByDirectionEnum[orderByDirection]
            },
            first: 10
        }
    })
    const tours = data && (data as IToursQueryData).tours

    const items: Array<ITour> = tours ? tours.edges.map((edge: ITourEdge) => edge.node) : []
    const hideCategories = useCallback(() => dispatch({ type: EToursSectionStateActionTypes.SetShowCategories, showCategories: false }), [])

    useEffect(() => {
        dispatch({ type: EToursSectionStateActionTypes.SetToursTotal, toursTotal: tours ? tours.total : 0})
    }, [tours])

    return (
        <>
            {loading ? <ItemListLoading key="loading" />
                : <InfiniteScroll
                    className={classNames('tours-infinite-scroll', { 'hide-for-large': showMap || showCategories })}
                    pageStart={0}
                    loader={<Loading key="loading" />}
                    loadMore={tours ? () =>
                        fetchMore({
                            variables: {
                                after: tours && tours.edges[tours.edges.length - 1].cursor
                            },
                            updateQuery: (previousResult, { fetchMoreResult: { tours: { edges: newEdges, pageInfo, total } } }) => {
                                return newEdges.length
                                    ? {
                                        tours: {
                                            __typename: previousResult.tours.__typename,
                                            edges: [...previousResult.tours.edges, ...newEdges],
                                            total,
                                            pageInfo
                                        }
                                    }
                                    : previousResult;
                            }
                        }) : () => { }}
                    hasMore={tours ? tours.pageInfo.hasNextPage : false}
                    useWindow={false}
                //useCapture={false}
                >
                    <Tours tours={items} />
                </InfiniteScroll>
            }
            {showMap && <ToursMapView />}
            <CategoriesFilter
                filterShow={showCategories}
                countryId={country && country.id || 1}
                applyFilter={hideCategories}
                resetFilter={hideCategories}
            />
        </>
    )
}))

export const ToursPageContent = withAppStoreValue(withToursSectionStoreValue<IToursPageContentToursStoreProps & IComponentCoreAppStoreProps>(ToursPageContentCore, ['dispatch', 'orderBy', 'orderByDirection', 'showMap', 'showCategories']), ['filter'])